import React, {useContext, useReducer, useState} from 'react';
import {Helmet} from 'react-helmet-async';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import {Store} from '../Store';
import {toast} from 'react-toastify';
import {getError} from '../utils';
import axios from 'axios';
import CryptoJS from 'crypto-js';

const reducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE_REQUEST':
      return {...state, loadingUpdate: true};
    case 'UPDATE_SUCCESS':
      return {...state, loadingUpdate: false};
    case 'UPDATE_FAIL':
      return {...state, loadingUpdate: false};

    default:
      return state;
  }
};

export default function ProfileScreen () {
  //const requestUrl = "https://www.skftechnologies.com:5000";
  const requestUrl = process.env.REACT_APP_API_URL;
  const {state, dispatch: ctxDispatch} = useContext (Store);
  const {userInfo} = state;
  const [name, setName] = useState (userInfo.name);
  const [email, setEmail] = useState (userInfo.email);
  const [phone, setPhone] = useState (userInfo.phone);
  const [password, setPassword] = useState ('');
  const [confirmPassword, setConfirmPassword] = useState ('');

  const [{loadingUpdate}, dispatch] = useReducer (reducer, {
    loadingUpdate: false,
  });

  const submitHandler = async e => {
    e.preventDefault ();

    // Validate password confirmation if password is provided
    if (password && password !== confirmPassword) {
      toast.error ('Passwords do not match');
      return;
    }

    try {
      dispatch ({type: 'UPDATE_REQUEST'});

      // Hash password on client side if provided using deterministic SHA256
      const hashedPassword = password
        ? CryptoJS.SHA256 (password).toString ()
        : '';

      const {data} = await axios.put (
        requestUrl + '/api/users/profile',
        {
          name,
          email,
          phone,
          password: hashedPassword,
        },
        {
          headers: {Authorization: `Bearer ${userInfo.token}`},
        }
      );
      dispatch ({
        type: 'UPDATE_SUCCESS',
      });
      ctxDispatch ({type: 'USER_SIGNIN', payload: data});
      localStorage.setItem ('userInfo', JSON.stringify (data));
      toast.success ('User updated successfully');
    } catch (err) {
      dispatch ({
        type: 'FETCH_FAIL',
      });
      toast.error (getError (err));
    }
  };

  return (
    <div className="container small-container">
      <Helmet>
        <title>User Profile</title>
      </Helmet>
      <h1 className="my-3">User Profile</h1>
      <form onSubmit={submitHandler}>
        <Form.Group className="mb-3" controlId="name">
          <Form.Label>Name</Form.Label>
          <Form.Control
            value={name}
            onChange={e => setName (e.target.value)}
            required
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="email">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            value={email}
            onChange={e => setEmail (e.target.value)}
            required
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="phone">
          <Form.Label>Phone Number</Form.Label>

          <Form.Control
            type="number"
            value={phone}
            onChange={e => setPhone (e.target.value)}
            required
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="password">
          <Form.Label>Password</Form.Label>
          <Form.Control
            type="password"
            onChange={e => setPassword (e.target.value)}
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="password">
          <Form.Label>Confirm Password</Form.Label>
          <Form.Control
            type="password"
            onChange={e => setConfirmPassword (e.target.value)}
          />
        </Form.Group>
        <div className="mb-3">
          <Button type="submit" disabled={loadingUpdate}>
            {loadingUpdate ? 'Updating...' : 'Update'}
          </Button>
        </div>
      </form>
    </div>
  );
}
